module.exports = {
  "zones": {
    "Brazil/Acre": ["z", {
      "wallclock": 1384041600000,
      "format": "-05",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": 1384056000000,
      "save": 0
    }, {
      "wallclock": 1214265600000,
      "format": "-04",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": 1214283600000,
      "save": 0
    }, {
      "wallclock": 590025600000,
      "format": "-05",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": 590043600000,
      "save": 0
    }, {
      "wallclock": -1767225600000,
      "format": "-05/-04",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": -1767209328000,
      "save": 0,
      "rules": "Brazil"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -16272000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Brazil": [{
      "from": 2018,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2038,
      "to": 1.7976931348623157e+308,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2037,
      "to": 2037,
      "month": 1,
      "day": [0, 22],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2035,
      "to": 2036,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2034,
      "to": 2034,
      "month": 1,
      "day": [0, 22],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2027,
      "to": 2033,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2026,
      "to": 2026,
      "month": 1,
      "day": [0, 22],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2024,
      "to": 2025,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2023,
      "to": 2023,
      "month": 1,
      "day": [0, 22],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 2016,
      "to": 2022,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2008,
      "to": 2017,
      "month": 9,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2015,
      "to": 2015,
      "month": 1,
      "day": [0, 22],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2013,
      "to": 2014,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2012,
      "to": 2012,
      "month": 1,
      "day": [0, 22],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2008,
      "to": 2011,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2007,
      "to": 2007,
      "month": 1,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2007,
      "to": 2007,
      "month": 9,
      "day": [0, 8],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2001,
      "to": 2006,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2006,
      "to": 2006,
      "month": 10,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2005,
      "to": 2005,
      "month": 9,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2004,
      "to": 2004,
      "month": 10,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2003,
      "to": 2003,
      "month": 9,
      "day": [7, 19],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2002,
      "to": 2002,
      "month": 10,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2000,
      "to": 2001,
      "month": 9,
      "day": [0, 8],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2000,
      "to": 2000,
      "month": 1,
      "day": [7, 27],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1999,
      "to": 1999,
      "month": 1,
      "day": [7, 21],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1999,
      "to": 1999,
      "month": 9,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1998,
      "to": 1998,
      "month": 2,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1998,
      "to": 1998,
      "month": 9,
      "day": [7, 11],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1997,
      "to": 1997,
      "month": 1,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1997,
      "to": 1997,
      "month": 9,
      "day": [7, 6],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1996,
      "month": 1,
      "day": [7, 11],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1996,
      "to": 1996,
      "month": 9,
      "day": [7, 6],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1993,
      "to": 1995,
      "month": 9,
      "day": [0, 11],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1994,
      "to": 1995,
      "month": 1,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1993,
      "to": 1993,
      "month": 0,
      "day": [7, 31],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1992,
      "to": 1992,
      "month": 1,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1992,
      "to": 1992,
      "month": 9,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1991,
      "to": 1991,
      "month": 1,
      "day": [7, 17],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1991,
      "to": 1991,
      "month": 9,
      "day": [7, 20],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1990,
      "to": 1990,
      "month": 1,
      "day": [7, 11],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1990,
      "to": 1990,
      "month": 9,
      "day": [7, 21],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1989,
      "to": 1989,
      "month": 0,
      "day": [7, 29],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1989,
      "to": 1989,
      "month": 9,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1988,
      "to": 1988,
      "month": 1,
      "day": [7, 7],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1988,
      "to": 1988,
      "month": 9,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1987,
      "month": 1,
      "day": [7, 14],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 1987,
      "month": 9,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1986,
      "to": 1986,
      "month": 2,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1986,
      "month": 9,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1985,
      "to": 1985,
      "month": 10,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1966,
      "to": 1968,
      "month": 2,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1966,
      "to": 1967,
      "month": 10,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1965,
      "to": 1965,
      "month": 0,
      "day": [7, 31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1965,
      "to": 1965,
      "month": 2,
      "day": [7, 31],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1965,
      "to": 1965,
      "month": 11,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1964,
      "to": 1964,
      "month": 2,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1963,
      "to": 1963,
      "month": 11,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1953,
      "to": 1953,
      "month": 2,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1949,
      "to": 1952,
      "month": 11,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1951,
      "to": 1952,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1950,
      "month": 3,
      "day": [7, 16],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1932,
      "to": 1933,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1932,
      "to": 1932,
      "month": 9,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1931,
      "to": 1931,
      "month": 9,
      "day": [7, 3],
      "time": 660,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};